import React from 'react';
import { View } from 'react-native';

import TouchableElement from '@components/common/touchableElement';
import { scale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { isWeb } from '@helpers';

export default ({ C, onPress, disable }: { C: any; onPress: () => any; disable?: boolean }) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle, pressHoverColor }: { boxStyle: any; pressHoverColor: any }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: C(pressHoverColor('Button/Light/Secondary')),
              width: scale(32),
              height: scale(32),
              borderRadius: scale(32) / 2,
              justifyContent: 'center',
              alignItems: 'center',
            },
            isWeb && {
              userSelect: 'none',
            },
          ]}
        >
          {disable ? (
            <Svg icon="chevronLeft" width={scale(11)} height={scale(16)} color="Label/Light/Quinary" key="disable-arrow" />
          ) : (
            <Svg icon="chevronLeft" width={scale(11)} height={scale(16)} color="Button/Light/Primary" key="active-arrow" />
          )}
        </View>
      )}
    </TouchableElement>
  );
};
